import { TRUST_STRIP } from "@/data/content";

/**
 * TrustStrip — inline row of commercial/safety promises, dot-separated.
 */
export const TrustStrip = ({ className = "" }) => (
  <div
    data-testid="trust-strip"
    className={`flex flex-wrap items-center gap-x-3 gap-y-2 text-sm font-medium text-ff-grey ${className}`}
  >
    {TRUST_STRIP.map((item, i) => (
      <span key={item} className="flex items-center gap-3">
        {i > 0 && <span className="h-1 w-1 rounded-full bg-ff-ember/70" />}
        <span className="whitespace-nowrap">{item}</span>
      </span>
    ))}
  </div>
);

export default TrustStrip;
